/* Bronvex Daniel-style layout — progressive enhancement only. The page reads and buying works without this file. */
(function () {
  'use strict';
  if (window.__BRONVEX_DN__) return;
  window.__BRONVEX_DN__ = true;

  function safe(fn, name) {
    try { fn(); } catch (e) { if (window.console) console.warn('[dn] ' + name + ' failed', e); }
  }

  function initReveal() {
    var items = document.querySelectorAll('.dn-reveal');
    if (!items.length) return;
    document.documentElement.classList.add('dn-js');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  function initGallery() {
    document.querySelectorAll('[data-dn-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-dn-main]');
      g.querySelectorAll('[data-dn-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.getAttribute('data-src');
          main.alt = b.getAttribute('data-alt') || '';
          g.querySelectorAll('[data-dn-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
        });
      });
    });
  }

  // Pack selector: sets the quantity on every cart form and the shown price.
  function initPacks() {
    var radios = document.querySelectorAll('.dn-pack input[type="radio"]');
    function apply(r) {
      document.querySelectorAll('[data-dn-qty]').forEach(function (q) { q.value = r.value; });
      document.querySelectorAll('[data-dn-price]').forEach(function (p) { p.textContent = r.getAttribute('data-price'); });
      document.querySelectorAll('[data-dn-was]').forEach(function (p) { p.textContent = r.getAttribute('data-was') || ''; });
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r); });
      if (r.checked) apply(r);
    });
  }

  // Delivery timeline with real dates: ships 1 business day after the order, then 2–6 business days in transit.
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function initEta() {
    var box = document.querySelector('[data-dn-eta]');
    if (!box) return;
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var now = new Date();
    var ship = addBusinessDays(now, 1);
    var a = addBusinessDays(ship, 2), b = addBusinessDays(ship, 6);
    box.querySelector('[data-dn-eta-0]').textContent = fmt(now);
    box.querySelector('[data-dn-eta-1]').textContent = 'By ' + fmt(ship);
    box.querySelector('[data-dn-eta-2]').textContent = fmt(a) + ' – ' + fmt(b);
    box.querySelector('[data-dn-eta-lead]').innerHTML = 'Order today and it should arrive between <b>' + fmt(a) + ' and ' + fmt(b) + '</b>.';
  }

  function initSticky() {
    var bar = document.querySelector('[data-dn-sticky]');
    var anchor = document.querySelector('[data-dn-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var on = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }).observe(anchor);
  }

  function boot() {
    safe(initReveal, 'reveal');
    safe(initGallery, 'gallery');
    safe(initPacks, 'packs');
    safe(initEta, 'eta');
    safe(initSticky, 'sticky');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
